<template>
  <div>
    <div class="Expander" v-for="(moment, index) in match_time" :key="index">
      <div class="Expander__trigger">
        <span v-if="moment.minute == 91">FT</span>
        <span v-else>{{moment.minute}}'</span>
        <h6 v-if="moment.timelineAction != null">{{moment.timelineAction.name}}</h6>
      </div>
      <div class="Expander__body">
        <div v-html="moment.comment" class="content"></div>
        <h5>
          <img
            v-if="moment.timelineAction != null"
            :src="moment.timelineAction.iconUrl"
            :class="moment.timelineAction.name == 'Goal!' ? 'goal': ''"
          />
          {{moment.playerName}}
        </h5>
      </div>
    </div>
    <div class="title">
      <h4>{{title}}</h4>
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    matchTime: {
      type: Array,
    },
    title: {
      type: String,
    },
  },
  computed: {
    match_time() {
      return this.matchTime.reverse();
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  position: relative;
  min-height: 4rem;
  padding-bottom: 1.5rem;
  margin-bottom: 3rem;

  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  @media only screen and (max-width: 768px) {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;

    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    margin-bottom: 1rem;
  }
  div {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    @media only screen and (max-width: 768px) {
      margin: 1rem 0;
    }
  }
  img {
    width: 25px;
    height: auto;
  }

  h4,
  p {
    font-size: 2.4rem;
    line-height: 1.66;
    font-weight: 700;
    margin-right: 20px;
    @media only screen and (max-width: 992px) {
      font-size: 20px;
    }
  }
  p {
    margin: 0 10px;
    span {
      margin: 0 2.5px;
      display: inline-block;
    }
  }
}

.Expander {
  margin-bottom: 3rem;
  position: relative;
  &:after,
  &:before {
    position: absolute;
    left: 4.5rem;
    width: 4px;
    height: 3rem;
    content: "";
    background-color: #e4e7f0;
  }
  &::before {
    top: -3rem;
  }
  &:after {
    bottom: -3rem;
  }
  &:last-of-type {
    &:before {
      display: none;
    }
  }
  &__trigger {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 1.6rem 3rem;
    background: #eff1f8;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    @media only screen and (max-width: 1199px) {
      padding: 1rem 1.5rem;
    }
    span {
      display: inline-block;
      width: 3.5rem;
      height: 3.5rem;
      background-color: #15224e;
      font-size: 1.4rem;
      font-weight: 500;
      line-height: 3.5rem;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      margin-right: 2rem;
    }
    h6 {
      font-size: 2rem;
      line-height: 1.7rem;
      text-transform: capitalize;
      margin-right: 1.5rem;
      @media only screen and (max-width: 599px) {
        font-size: 1.8rem;
      }
    }
  }
  &__body {
    padding: 2.5rem 3rem 3rem;
    transition: all 0.5s ease-in-out;
    overflow: hidden;
    background: #fff; //#dee2e6 //#f1f1f1
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    border: 1px solid #f2f2f2;
    border-top: none;
    @media only screen and (max-width: 599px) {
      padding: 1.5rem;
    }
    .content {
      margin-bottom: 15px;
      img {
        width: 60rem;
        height: auto;
      }
      p {
        margin-bottom: 1.5rem;
      }
    }
    h5 {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      font-size: 1.8rem;
      line-height: 2.5rem;
      font-weight: 500;
      img {
        width: 20px;
        margin-right: 10px;
        &.goal {
          -webkit-filter: contrast(200%) invert(1);
          filter: contrast(200%) invert(1);
        }
      }
      span {
        font-weight: 400;
        margin-right: 0.4rem;
        &.number {
          font-weight: 600;
          margin-right: 0.5rem;
        }
      }
      span.icon {
        margin: 0.25rem 0;
        margin-right: 1.5rem;
      }
    }
  }
}
.game-finish {
  .Expander:first-of-type:before {
    display: none;
  }
}
</style>